import { FormFieldGroup, FormInput, FormLabel, FormSelect, RoleHelpPopover } from '$components'
import { Input } from '.'
import { Role } from '$api-client/types.gen'
import { useUpdateMemberForm } from '.'

export function UpdateMemberFormContent() {
  const { defaultValues } = useUpdateMemberForm()

  return (
    <div className="flex flex-col gap-stack-section flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.FirstName}>
          First Name
        </FormLabel>

        <FormInput
          name={Input.FirstName}
          placeholder="Enter first name..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.LastName}>
          Last Name
        </FormLabel>

        <FormInput
          name={Input.LastName}
          placeholder="Enter last name..."
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <div className="flex items-center gap-stack-tight">
          <FormLabel htmlFor={Input.Role}>
            Role
          </FormLabel>
          <RoleHelpPopover />
        </div>

        <FormSelect
          name={Input.Role}
          placeholder="Select role..."
          disabled={defaultValues?.role?.value === Role.SUPER_ADMIN}
          options={[
            { id: Role.ADMIN, value: Role.ADMIN },
            { id: Role.GROOMER, value: Role.GROOMER },
          ]}
        />
      </FormFieldGroup>
    </div>
  )
}
